export const APP_USER_MAPPING = "/user-mapping";
export const APP_USER_MAPPING_IMPORT = "/user-mapping/import-user-map";
